import { render } from "./FilePickerStorage.vue?vue&type=template&id=3e98ff16"
import script from "./FilePickerStorage.vue?vue&type=script&lang=js"
export * from "./FilePickerStorage.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bomo-staging/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__